var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",style:({
    'background-image': ("url(" + _vm.img + ")"),
    'background-repeat': 'no-repeat',
    'background-size': '100% 100%',
  })},[_c('Logos'),_c('dir',{class:['text', _vm.textClose]},[_c('span',[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }